<template>
    <div class="layout-reminder-popup layout-reminder-detail" @click.stop="clickReminder">
        <!-- 底部遮罩层 -->
        <div v-if="startCheck && (!detailExtTime[curKey] || (detailExtTime[curKey] && detailExtTime[curKey] < 0))" class="layout-overlay"></div>

        <!-- 1、名字弹框 -->
        <div v-if="detailExtTime[detailKeyArr[0]] && detailExtTime[detailKeyArr[0]] < 0" class="layout-reminder-content">
            <div class="title-middle layout-reminder-detail-title">
                <span class="layout-rdt-span" v-bind:class="{'title-word-small': personInfo.f_name && personInfo.f_name.length > 6 && personInfo.f_name.length <= 10, 'title-word-smallest' : personInfo.f_name && personInfo.f_name.length > 10}">{{personInfo.f_name}} {{personInfo.sex == 0 ? '男' : '女'}}</span>
            </div>
            <div class="layout-reminder-detail-bubble-1"></div>
        </div>

        <!-- 2、命盘弹框 -->
        <div v-show="detailExtTime[detailKeyArr[1]] && detailExtTime[detailKeyArr[1]] < 0" class="layout-reminder-content">
            <div class="detail-content layout-reminder-detail-fate">
                <fate-panel 
                    v-bind:hideSideBar="true" 
                    v-bind:fateData="detailFateListData" 
                    v-bind:fateInfo="detailFateInfo">
                </fate-panel>
            </div>
            <div class="layout-reminder-detail-bubble-2"></div>
        </div>

        <!-- 3、浮窗弹框 -->
        <div v-if="detailExtTime[detailKeyArr[2]] && detailExtTime[detailKeyArr[2]] < 0"  class="layout-reminder-content">
            <div class="layout-reminder-detail-bubble-3"></div>
        </div>

        <!-- 4、标签弹框 -->
        <!-- <div v-if="detailExtTime[detailKeyArr[3]] && detailExtTime[detailKeyArr[3]] < 0" class="layout-reminder-content">
            <div class="layout-reminder-detail-label">
                <span class="layout-reminder-detail-span"><i class="iconbg icon-label"></i>标签</span>
            </div>
            <div class="layout-reminder-detail-bubble-4"></div>
        </div> -->

    </div>
</template>

<script>
import FatePanel from '../panel/FatePanel.vue'
export default {
    name: 'ReminderDetail',
    components: { FatePanel },
    computed: {
        personInfo(){
            return this.$store.state.detail.personInfo
        },
        detailFateInfo(){
            return this.$store.state.detail.fatefortune.fateInfo
        },
        detailFateListData(){
            return this.$store.state.detail.fatefortune.fateListData
        },
        detailExtTime() {
            return this.$store.state.reminder.detailExtTime
        },
        detailKeyArr() {
            return this.$store.state.reminder.detailKeyArr
        }
    },
    data() {
        return {
            startCheck: false,
            keyIndex: 0,
            curKey: ''
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initDom();
        }, 300);
        setTimeout(() => {
            me.checkData();
        }, 1000);
    },
    methods: {
        initDom() {
            this.$el.style.width = innerWidth + 'px';
            this.$el.style.height = innerHeight + 'px';
            var detailDiv = document.getElementsByClassName("detail-main-panel")[0];
            var contentDiv = document.getElementsByClassName("layout-reminder-detail-fate")[0];
            var height = detailDiv && detailDiv.style ? detailDiv.style.height : '',
                padTop = detailDiv && detailDiv.style ? detailDiv.style.paddingTop : '';
            // console.error('initDom------', height, padTop)
            // 做一层容错
            if(contentDiv && detailDiv){
                contentDiv.style.height = height;
                contentDiv.style.paddingTop = padTop;
            }
        },
        initLabelDom() {
            var titleDiv = document.getElementsByClassName("title-bar")[0];
            var contentDiv = document.getElementsByClassName("layout-detail-fate")[0];
            var labelDiv = document.getElementsByClassName('layout-reminder-detail-label')[0],
                labelBubble = document.getElementsByClassName('layout-reminder-detail-bubble-4')[0];
            labelDiv.style.top = titleDiv.clientHeight + contentDiv.clientHeight + 3 + 'px';
            labelBubble.style.top = titleDiv.clientHeight + contentDiv.clientHeight + labelDiv.clientHeight + 10 + 'px';
        },
        checkData() {
            var me = this,
                curPath = this.$router.history.current.path;
            if(curPath.indexOf('detail') == -1 || curPath.indexOf('label') != -1) {
                this.$store.state.reminder.showDetailReminder = false;
                // this.$store.state.reminder.showVersionReminder = true;
                this.$store.state.reminder.showDownloadReminder = true;
                return;
            }
            this.startCheck = true;
            this.$store.state.reminder.showVersionReminder = false;
            this.$store.state.reminder.showDownloadReminder = false;

            this.curKey = this.detailKeyArr[this.keyIndex];
            console.log('RemindDetail:::::::checkData------', this.curKey, this.detailExtTime[this.curKey])
            if(!this.detailExtTime[this.curKey] || this.detailExtTime[this.curKey] == -1) {
                this.$set(this.$store.state.reminder.detailExtTime, this.curKey, -1);
                // 自动跳到下一步
                // setTimeout(() => {
                //     me.clickReminder();
                // }, 5000);
                // 
                if(this.curKey == 'label') {
                    setTimeout(() => {
                        me.initLabelDom();
                    }, 0);
                }
            }else {
                if(this.keyIndex < this.detailKeyArr.length - 1) {
                    this.keyIndex++;
                    // this.checkData();
                }else {
                    this.$store.state.reminder.showDetailReminder = false;
                    // this.$store.state.reminder.showVersionReminder = true;
                    this.$store.state.reminder.showDownloadReminder = true;
                }
            }
        },
        clickReminder() {
            if(this.curKey == '') { return; }
            var params = {};
                params['detailExtTime'] = Object.assign({}, this.detailExtTime);
                params['detailExtTime'][this.curKey] = 1;
            console.log('clickReminder', params, this.keyIndex)
            
            var me = this;
            this.$store.dispatch('reminder/udpateExtList', {
                params: params,
                cb: function() {
                    if(me.keyIndex < me.detailKeyArr.length - 1) {
                        me.keyIndex++;
                        me.checkData();
                    }else {
                        me.curKey = '';
                        me.startCheck = false;
                        me.$store.state.reminder.showDetailReminder = false;
                        // me.$store.state.reminder.showVersionReminder = true;
                        me.$store.state.reminder.showDownloadReminder = true;
                    }
                }
            })
        }
    }
}
</script>